import React from 'react';
import PropTypes from 'prop-types';

// Relements
import Table from 'relements/build/esm/ui/table';

// Constants
import {
  SUPPORTED_VARIABLES,
  SUPPORTED_OPERATORS,
} from '../../../const/promptTrigger';

// Components
import SocialChannelIcons from './components/SocialChannelIcons';

import styles from './PromptTriggerInfoView.scss';

const VARIANT_TABLE_COLUMNS = [
  {
    title: 'Message',
    width: '50%',
    className: styles.categoryTableHeaderItem,
  },
  {
    title: 'User Message',
    width: '50%',
    className: styles.categoryTableHeaderItem,
  },
];

const SOCIAL_CHANNELS_COLUMN = [
  {
    title: 'Heading Text',
    width: '38%',
    className: styles.categoryTableHeaderItem,
  },
  {
    title: 'Body Text',
    width: '38%',
    className: styles.categoryTableHeaderItem,
  },
  {
    title: 'Channels',
    width: '24%',
    className: styles.categoryTableHeaderItem,
  },
];

export default class PromptTriggerInfoView extends React.Component {
  render() {
    const { rules, trigger_type } = this.props;
    const ruleList = rules.rule_list || [];

    return (
      <div>
        <div className={styles.categoryWrapper}>
          <div className={styles.categoryHeader}>
            {!trigger_type ? 'Message Variants' : 'Social Channels'}
          </div>
          <Table
            simple
            rows={this._generateVariantTableData()}
            columns={
              !trigger_type ? VARIANT_TABLE_COLUMNS : SOCIAL_CHANNELS_COLUMN
            }
            className={styles.categoryTable}
          />
        </div>

        <div className={styles.categoryWrapper}>
          <div className={styles.categoryHeader}>Trigger Rules</div>
          <div className={styles.triggerRules}>
            {ruleList.map((rule, index) => {
              return (
                <React.Fragment key={index}>
                  <div className={styles.triggerRule}>
                    <div className={styles.triggerRuleChip}>
                      {SUPPORTED_VARIABLES[rule.variable].label}
                    </div>
                    <div className={styles.triggerRuleChip}>
                      {SUPPORTED_OPERATORS[rule.operator]}
                    </div>
                    {rule.value !== undefined &&
                      String(rule.value).length > 0 && (
                        <div className={styles.triggerRuleChip}>
                          {rule.value}
                        </div>
                      )}
                  </div>
                  {index !== ruleList.length - 1 && (
                    <div className={styles.triggerRuleClause}>
                      {rules.clause}
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  _generateVariantTableData = () => {
    const { social_prompt, variants, trigger_type } = this.props;
    const tableData = !trigger_type
      ? variants.map((variant, index) => {
          const row = {
            id: index,
            columns: [],
          };
          row.columns.push(
            this._generateColumn(
              <div className={styles.message}>{variant.message}</div>
            )
          );
          row.columns.push(
            this._generateColumn(
              <div className={styles.gogoMessage}>{variant.gogo_message}</div>
            )
          );
          return row;
        })
      : [
          {
            id: 0,
            columns: [
              this._generateColumn(
                <div className={styles.message}>{social_prompt?.header}</div>
              ),
              this._generateColumn(
                <div className={styles.message}>{social_prompt?.body}</div>
              ),
              this._generateColumn(
                <SocialChannelIcons channels={this._getActiveChannels()} />
              ),
            ],
          },
        ];
    return tableData;
  };

  _generateColumn = (content) => ({
    content,
  });

  _getActiveChannels = () => {
    return this.props.social_prompt.channels.filter((channel) => {
      let isEnabled = false;
      this.props.omniChannelWidget.map((widgetChannel) => {
        if (widgetChannel.type === channel.type) {
          isEnabled = widgetChannel.enabled && channel.enabled;
        }
      });
      return isEnabled;
    });
  };
}

PromptTriggerInfoView.propTypes = {
  rules: PropTypes.shape({
    clause: PropTypes.string.isRequired,
    rule_list: PropTypes.arrayOf(
      PropTypes.shape({
        variable: PropTypes.string.isRequired,
        operator: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
      })
    ),
  }).isRequired,
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
      actionable_text: PropTypes.string,
      gogo_message: PropTypes.string,
    })
  ).isRequired,
  trigger_type: PropTypes.number,
  social_prompt: PropTypes.shape({
    header: PropTypes.string,
    body: PropTypes.string,
    channels: PropTypes.array,
  }),
  omniChannelWidget: PropTypes.array,
};
